import React from 'react'

import { FormattedMessage } from '@dragonraider5/react-intl'
import Modal from '../../../components/Modal/Modal'
import H1 from '../../../components/H1'
import FormRow from '../../../components/FormFields/FormRow'
import CheckboxField from '../../../components/FormFields/CheckboxField'
import FormAction from '../../../components/FormFields/FormAction'
import FormError from '../../../components/FormFields/FormError'
import formMessages  from '../../Register/messages'

import { IS_TRUE } from '../../../utils/validations/constants'
import { showFieldError, renderValidation } from '../../../utils/validations'
import { getExceptionMessage } from '../../../utils/exceptions'

function NewApplicationModal({
  handleClose,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  status = {},
  isSubmitting
}) {
  return (
    <Modal handleClose={handleClose}>
      <H1 size='small'>Comenzar solicitud</H1>
      <form onSubmit={handleSubmit}>
        <FormRow leader>
          <CheckboxField
            type='checkbox'
            name='power'
            value={values.power}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('power', { errors, touched })}
            help={renderValidation('power', { errors, touched }, { [IS_TRUE]: formMessages.formValidationsPower })}
            label={<FormattedMessage {...formMessages.formFieldPower} />}
          />
        </FormRow>
        {status.error && (
          <FormError>
            <FormattedMessage {...getExceptionMessage(status.error)} />
          </FormError>
        )}
        <FormAction
          type='submit'
          disabled={isSubmitting}
        >
          Comenzar
        </FormAction>
      </form>
    </Modal>
  )
}

export default NewApplicationModal
